import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

// Pista discreta (una sola vegada) per descobrir el joc dels micos
export default function MonkeyHint() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("km_monkey_hint") === "seen") return;
    const t = setTimeout(() => setShow(true), 2500);
    return () => clearTimeout(t);
  }, []);

  const dismiss = () => {
    setShow(false);
    localStorage.setItem("km_monkey_hint", "seen");
  };

  useEffect(() => {
    if (!show) return;
    const t = setTimeout(dismiss, 8000);
    return () => clearTimeout(t);
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: -12, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: -12, scale: 0.9 }}
          transition={{ type: "spring", stiffness: 260, damping: 18 }}
          className="fixed right-4 top-16 z-50 max-w-[15rem] rounded-2xl bg-forest px-4 py-3 text-left text-paper paper-shadow sm:right-6"
          data-testid="monkey-hint"
        >
          <button onClick={dismiss} className="absolute right-2 top-2 text-paper/70 hover:text-paper" aria-label="Tancar pista">
            <X className="h-4 w-4" />
          </button>
          <p className="pr-4 font-body text-sm font-semibold leading-snug">
            Psst… hi ha 5 micos amagats darrere d'alguns panells. Toca'ls per trobar-los! <span role="img" aria-label="mico">🐒</span>
          </p>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
